import { Dropdown, Input, Table } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteGroup,
  fetchPersonnelFolders,
  setFolderObj,
} from "../../features/folder/folderSlice";
import toast from "react-hot-toast";
import AddFolderModal from "./modal/AddFolderModal";
import svg27 from "../../assets/svg/svg27.svg";
import DeleteModal from "../../components/DeleteModal";
import svg38 from "../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import FilterModal from "./modal/FilterModal";
import { save } from "../../features/save/saveSlice";
import { fetchCoBranch, fetchCountry, fetchDepts, fetchGender, fetchPayrollType, fetchStaffCategory, fetchStaffGrade, fetchStaffStatus, fetchStaffTerm } from "../../features/dropdown/dropdownSlice";

export default function PersonnelFolderTable({ 
  handleAddFolder,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fldLoading, personnelFolders, deleteLoading, personnelCount } =
    useSelector((state) => state.folder);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [hasSelected, sethasSelected] = useState(false);
  const [activeFolder, setactiveFolder] = useState({});
  const [search, setsearch] = useState("");

  const [open, setopen] = useState(false);

  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  async function handleFolderChange(item) {
    await dispatch(setFolderObj(item));
    await setactiveFolder(item);
    await navigate(`/personnel/folder`);
  }

  const [prodd1, setProdd1] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };
  const handleDelete = async () => {
    const updatedProdd1 = { ...prodd1, ssId: "Suspended" };
    const res = await dispatch(
      save({
        url: "hr/savePersonnel.action",
        ...updatedProdd1,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      handleFetch();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleView = () => {
    handleFolderChange(prodd1);
  };

  const handleEdit = () => {
    setopen(true);
  };

  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Details
        </Link>
      ),
    },

    {
      key: "1",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },

    // {
    //   key: "2",
    //   label: (
    //     <div
    //       onClick={showModalDelete}
    //       className="flex  text-[16px] font-sans   !text-lightBlack"
    //     >
    //       Disable
    //     </div>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "Personnel No",
      sorter: (a, b) => a.ppPfno.localeCompare(b.ppPfno),
      render: (item) => (
        <div
          className="cursor-pointer"
          onClick={() => handleFolderChange(item)}
        >
          {item?.ppPfno}
        </div>
      ),
    },
    {
      title: "Personnel Name",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
    },
    {
      title: "Gender",
      dataIndex: "gdName",
      sorter: (a, b) => a.gdName.localeCompare(b.gdName),
    },
    {
      title: "Status",
      dataIndex: "ssStatusname",
      sorter: (a, b) => a.ssStatusname.localeCompare(b.ssStatusname),
    },
    {
      title: "Department",
      dataIndex: "coDeptname",
      sorter: (a, b) => a.coDeptname.localeCompare(b.coDeptname),
    },
    {
      title: "Grade",
      dataIndex: "sgGradename",
      sorter: (a, b) => a.sgGradename.localeCompare(b.sgGradename),
    },
    {
      title: "Position",
      dataIndex: "spPositionname",
      sorter: (a, b) => a.spPositionname.localeCompare(b.spPositionname),
    },
    {
      title: "Employment Terms",
      dataIndex: "stEngtrmname",
      sorter: (a, b) => a.stEngtrmname.localeCompare(b.stEngtrmname),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd1(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [rowId, setRowId] = useState([]);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleEmployeeToReturns = async (selectedRows) => {
    await setRowId(selectedRows);
    // await showModalGroup();
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchPersonnelFolders());
    await setFilters([]);
  };

  async function handleFetch() {
    await dispatch(fetchPersonnelFolders());
  }
  
  async function fetchCountryData() {
    await dispatch(fetchCountry());
  }
  async function fetchGenderData() {
    await dispatch(fetchGender());
  }
  async function fetchStaffGradeData() {
    await dispatch(fetchStaffGrade());
  }
  async function fetchStaffTermData() {
    await dispatch(fetchStaffTerm());
  }
  async function fetchStaffCategoryData() {
    await dispatch(fetchStaffCategory());
  }
  async function fetchPayrollTypeData() {
    await dispatch(fetchPayrollType());
  }
  async function fetchCoBranchData() {
    await dispatch(fetchCoBranch());
  }
  async function fetchDeptsData() {
    await dispatch(fetchDepts());
  } 
  async function fetchStaffStatusData() {
    await dispatch(fetchStaffStatus());
  }

  // useEffect(() => {}, [personnelFolders, activeFolder]);

  useEffect(() => {
    handleFetch();
    // fetchCountryData()
    // fetchGenderData()
    // fetchStaffGradeData()
    // fetchStaffTermData()
    // fetchStaffCategoryData()
    // fetchPayrollTypeData()
    // fetchCoBranchData()
    // fetchDeptsData()
    // fetchStaffStatusData()
  }, []);
 
  return (
    <>
      <div className="flex flex-col  w-full">
        <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-5">
          Employees Profile 
        </h3>
        <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
          <div className="flex items-center">
            <span>
              {" "}
              <button
                onClick={showModalFilter}
                type="button"
                className={`bg-transparent flex items-center gap-x-'1' ${
                  Object?.keys(formData)?.length > 0
                    ? "!text-[#5688E5]"
                    : "inherit"
                }`}
              >
                <MaterialIcon color="#141414" icon="filter_list" />
                Filters
              </button>
            </span>
            {Object?.keys(formData)?.length > 0 && (
              <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                :{Object?.keys(formData)?.length}
                <img src={svg38} alt="svg38" onClick={handleClearFilters} />
              </span>
            )}
          </div>
          {window?.location?.hash != "#/dashboard-main" && (
            <div className="flex lg:flex-row flex-col lg:items-center items-start lg:gap-x-10 gap-y-5">
              <div className="w-[229px]">
                <button onClick={() => handleAddFolder()} className="cstm-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                      fill="#FFCD47"
                    />
                  </svg>
                  <span className="ml-1">Add personnel</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="dash-inner-page mt-[24px] mb-10 max-w-full w-full overflow-x-auto">
        <section>
          <Table
            rowSelection={false}
            className="mt-[1.31rem] w-full"
            scroll={{
              x: 800,
            }}
            rowKey={(record) => record?.ppId}
            columns={columns}
            dataSource={personnelFolders}
            loading={fldLoading}
            pagination={{
              position: ["bottomCenter"],
              current: pageIndex + 1,
              total: personnelCount,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                handleFetch(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </section>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd1}
        handleDelete={handleDelete}
        loading={deleteLoading}
        content={`Are you sure you want to delete ${prodd1?.ppFullname}?`}
        title={`Remove ${prodd1?.ppFullname}`}
      />

      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />
    </>
  );
}
